import React, { useContext } from "react";
import { ThemeContext } from "../lib/main-context";
import { useTranslation } from "../i18n/TranslationProvider";

import PillButton from "./StyledComponents/PillButton";

const ThemeChanger = ({ align = "end" }) => {
  const { dark, toggleTheme } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <div className={`d-flex justify-content-${align}`}>
      <PillButton className="pillBtn" onClick={() => toggleTheme()}>
        {dark ? t("dashboard.darkMode.off") : t("dashboard.darkMode.on")}
      </PillButton>
    </div>
  );
};

export default ThemeChanger;